export type ProductDataType = {
    EligibleForHomeTryOn: string;
    brand: string;
    categories: string[];
    color: string;
    coupon?: string;
    coupon_price?: string;
    dy_display_price: string;
    final_price: string | number;
    frame_type: string;
    gender: string;
    group_id: string;
    image_url: string;
    in_stock: boolean;
    keywords: string[];
    name: string;
    photoV2: string;
    photoV2_angle: string;
    price: number;
    product_badge: string;
    product_id: string;
    publish_time: string;
    quantity: string;
    size: string;
    url: string;
    variation: string;
    window_name: string;
    sku: string;
    currentLocation?: string;
    isEligibleForRx: string;
    eyewear_type: string;
    is_3d_model_available: 'TRUE' | 'FALSE';
};

export const EEC_RECOMMENDATION = {
    VIEWED_IMPRESSION: 'EEC_Recommendation_viewed_impressions',
};
